<template>
  <div class="searches">
    <div
      v-if="$slots.items"
      class="searches-items"
    >
      <slot name="items" />
    </div>

    <div
      v-if="$slots.right"
      class="searches-right"
    >
      <slot name="right" />
    </div>

    <div
      v-if="$slots.buttons"
      class="searches-buttons"
    >
      <slot name="buttons" />
    </div>

    <div style="clear: both;" />
  </div>
</template>

<script>
export default {
  name: 'Searches'
}
</script>

<style scoped>
  .searches {
  }

  .searches-items {
    margin-bottom: 5px;
  }

  .searches-right {
    float: right;
  }

  .searches-buttons {
    margin-bottom: 5px;
  }
</style>
